<template>
    <datePicker format="DD-MM-YYYY" input-class="mx-input datePickerStyle" class="my-datepicker" :placeholder="placeholder" v-model="date" :lang="lang" calendar-class="my-datepicker_calendar" @change="changeDate"></datePicker>
</template>

<script>
import datePicker from 'vue2-datepicker';
export default {
    components: {
        datePicker
    },
    props: {
        placeholder: String,
        format: String,
        value: String|Date
    },
    data () {
        return {
            date: '',
            lang: {
                days: [
                    "Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"
                ],
                months: [
                    "Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"
                ]
            }
        }
    },

    methods: {
        changeDate (date) {
            this.$emit("input", date);
        }
    },

    created () {
        this.date = this.value;
    }
}
</script>

<style scoped>
    .datePickerStyle {
        height: 50px;
    }
</style>
